/** The operating currencies offered on the Subscribe screen (set once; MM-D-21). */
export const SUBSCRIBE_CURRENCIES: readonly string[] = [
  'USD',
  'CAD',
  'EUR',
  'GBP',
  'MXN',
  'CRC',
  'AUD',
  'NZD',
  'CHF',
  'JPY',
];

const EURO_REGIONS = [
  'AT',
  'BE',
  'CY',
  'DE',
  'EE',
  'ES',
  'FI',
  'FR',
  'GR',
  'HR',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MC',
  'MT',
  'NL',
  'PT',
  'SI',
  'SK',
] as const;

/** Region → currency, for the regions whose currency the Subscribe screen offers. */
const REGION_CURRENCY: Readonly<Record<string, string>> = {
  US: 'USD',
  CA: 'CAD',
  GB: 'GBP',
  MX: 'MXN',
  CR: 'CRC',
  AU: 'AUD',
  NZ: 'NZD',
  CH: 'CHF',
  LI: 'CHF',
  JP: 'JPY',
  ...Object.fromEntries(EURO_REGIONS.map((region) => [region, 'EUR'])),
};

/**
 * The operating currency a locale suggests (TMMAPP-0117 B7): its region (`fr-FR` → FR, a bare
 * `fr` maximized to FR) mapped to a currency the Subscribe screen offers; anything else is null.
 */
export function currencyForLocale(locale: string | null | undefined): string | null {
  if (!locale) return null;
  let region: string | undefined;
  try {
    region = new Intl.Locale(locale).maximize().region;
  } catch {
    return null;
  }
  const currency = region !== undefined ? REGION_CURRENCY[region] : undefined;
  return currency !== undefined && SUBSCRIBE_CURRENCIES.includes(currency) ? currency : null;
}

/** The person's served currency, else the locale's, else USD. */
export function defaultSubscribeCurrency(
  served: string | null,
  locale: string | null | undefined,
): string {
  if (served !== null && SUBSCRIBE_CURRENCIES.includes(served)) return served;
  return currencyForLocale(locale) ?? 'USD';
}
